export default "Hello! Can I help you book your appointment?\n";